import { ConfigBase, TenantBase } from "@obg/global";

import { EnvironmentContext } from "./config/environment/environment.model";
import { Device } from "./device/device.model";

export interface GlobalConfig<C extends TenantBase<C> = any> {
	appContext: Record<string, any>;
	device?: Device;
	prefetchData: Record<string, any>;
	languageCode: string;
	environmentContext: EnvironmentContext;
	config?: Record<string, any>;
	configBase?: ConfigBase<C>;
	initialTelemetryData?: Record<string, any>;
	tenant?: string;
	jurisdiction?: string;
	dimensions?: string[];
	disableMemoizationClear?: boolean;
}

export const REGISTER_KEY_DEPENDENCY_TOKEN = "T_REGISTER_KEY_DEPENDENCY_TOKEN";
export const CDS_RES_HEADER = "x-obg-cds";
export type RegisterKeyDependencyFn = (url: string, headers: Record<string, string>) => void;
